export default "__VITE_ASSET__k5iK5yL6__"